import { Activity, SubmissionMainStatus, SubmissionStatus } from "@graphql/generated-graphql";

export const isActivityCompleted = (activity: Activity) => {
  return activity?.studentSubmissions?.[0]?.mainStatus === SubmissionMainStatus.Done &&
  activity?.studentSubmissions?.[0]?.status !== SubmissionStatus.Reassigned
}